<template>
  <v-container>
    <v-layout row wrap justify-start class="mt-3">
      <v-card
        class="mx-auto"
        max-width="344"
      >
        <v-card-text>
          <p class="display-1 text--primary">
            {{$t('error_page.error_title')}}
          </p>
          <div class="text--primary">
            {{$t('error_page.error_message')}}
          </div>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'ErrorPage'

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ErrorPage.vue